import type { FacetSelectedPayload } from '@awaze/mfe-common.contexts.tms'
import { TmsContextType } from '@awaze/mfe-common.contexts.tms'
import {
  DataLayerEventType,
  DataLayerFactory,
} from '@awaze/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

interface FireFacetSelectedEventProps {
  clickedFeature: FacetSelectedPayload['feature']
  tms: TmsContextType
}

export const fireFacetSelectedEvent = ({
  clickedFeature,
  tms,
}: FireFacetSelectedEventProps): void => {
  new DataLayerFactory().getEvent(DataLayerEventType.FacetSelected).update(
    tms,
    {
      feature: clickedFeature,
    },
    dataLayerErrorHandler,
  )
}
